<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="create_new_valuta" ttGoto="valuta" [ttGotoParms]="{ valuta_id: '+' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListValutas"></tt-list>
</tt-page>
